import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {WizardInterfaces} from '../../../wizard.namespace';
import {EquipmentGroupPreview} from '../equipment-group-preview/equipment-group-preview';
import {ModelsInterfaces} from '@namespaces/models.namespace';
import Method = ModelsInterfaces.Method;


@Component({
    selector: 'app-equipment-groups-summary',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: 'equipment-groups-summary.component.html',
    styles: [`
        :host {
            font-size: 13px;
            display: block;
            padding-top: 20px;
        }
    `]
})

export class EquipmentGroupsSummaryComponent implements OnChanges {
    @Input() groups: EquipmentGroupPreview[] = [];
    @Input() method: Method;

    @Output() groupSelect = new EventEmitter<WizardInterfaces.ApparatusStepGroup>();

    public requiredGroups: EquipmentGroupPreview[] = [];
    public allGroupsValid = false;

    constructor() {}

    ngOnChanges() {
        this.requiredGroups = this.groups.filter(g => g.required);
        this.allGroupsValid = this.requiredGroups.every(g => g.valid);
    }

    onGroupClick(group: EquipmentGroupPreview) {
        this.groupSelect.emit(group.rawData);
    }
}
